import { render, staticRenderFns } from "./HelpWithMyOrder.vue?vue&type=template&id=7b171636&scoped=true"
import script from "./HelpWithMyOrder.vue?vue&type=script&lang=js"
export * from "./HelpWithMyOrder.vue?vue&type=script&lang=js"
import style0 from "./HelpWithMyOrder.vue?vue&type=style&index=0&id=7b171636&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b171636",
  null
  
)

export default component.exports